<template lang="pug">
router-view
</template>

<script>
import Listado from './components/listado/index'

export default {
	name: 'app',
	components: {
		'listado': Listado
	}
}
</script>



// WEBPACK FOOTER //
// src/modulos/mis-contratos/vue/App.vue